
/**
 * Cookie Utilities Module  
 * @module utilities/cookies
 * 
 */

/**
 * Get Cookie by Name
 * @param {*} name The name of the cookie you want to examine
 */
export function get(name) {
  let value = "; " + document.cookie;
	let parts = value.split("; " + name + "=");
  
  if (parts.length == 2) return parts.pop().split(";").shift();
}

/**
 * Sets a cookie
 * Uses SameSite=Strict and Secure
 * @param {*} name Name of cookie
 * @param {*} data Value of cookie to save
 * @param {*} days Number of days the cookie should live
 */
export function set(name, data, days) {
  let expires = new Date(+new Date() + (days * 24 * 60 * 60 * 1000)).toUTCString();

  document.cookie = `${name}=${data}; SameSite=Strict; Secure; expires=${expires} `;
}
